module.exports = __webpack_public_path__ + "img/gitea.827bc34d.png";